import { SuccessorBorrowers } from './SuccessorBorrowers';

export default SuccessorBorrowers;
